// extracted by mini-css-extract-plugin
export default {"meta-info":"create-subscription_meta-info__XiJLl"};